import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomerCareBookingData, CustomerCareService } from 'pg-lib/services/customer-care.service';
import { EnvironmentService } from 'pg-lib/services/environment.service';

@Component({
    selector: 'app-totem-customer-care-call',
    templateUrl: './totem-customer-care-call.component.html',
    styleUrls: ['./totem-customer-care-call.component.scss'],
    standalone: false
})
export class TotemCustomerCareCallComponent implements OnInit, OnDestroy {

    isLoading = false;
    isSaving = false;

    bookingData:CustomerCareBookingData = null;

    private _showChatInterval = null;
    showChat = false;
    isPast = false;

    constructor(private route:ActivatedRoute, private environmentService:EnvironmentService, private customerCareService:CustomerCareService) { }

    ngOnInit(): void {
        if(this.isChatEnabled()) {
            this.route.params.subscribe((params) => {
                this.bookingData = null;
    
                if(params.id != null) {
                    this.isLoading = true;
                    this.customerCareService.getBooking(params.id).subscribe((data) => {
                        this.isLoading = false;
                        this.bookingData = data;
                        this._checkShowChat();
                    })
                }
            })  

            this._showChatInterval = setInterval(() => {
                this._checkShowChat()
            }, 2500)
        }      
    }

    ngOnDestroy(): void {
        clearInterval(this._showChatInterval)
    }

    private _checkShowChat() {
        this.showChat = false;
        this.isPast = false;

        if(this.bookingData != null && this.bookingData.status == 'confirmed') {
            let _startTime = new Date(this.bookingData.start_datetime + '+00:00');

            let _timeDiff = _startTime.getTime() - Date.now();
            let _timeAround = 1000 * 60 * 60 * 12;

            if(Math.abs(_timeDiff) < _timeAround) {
                this.showChat = true;
            }
            
            if(_timeDiff < 0) this.isPast = true;
        }
    }

    canConfirm() {
        return !this.isSaving && this.bookingData != null && this.bookingData.status == 'pending';
    }

    doConfirm() {
        if(this.canConfirm()) {
            this.isSaving = true;

            this.customerCareService.confirmBooking(this.bookingData.pid).subscribe((data) => {
                this.isSaving = false;

                if(data != null) {
                    this.bookingData = data;
                }
            })
        }
    }

    isChatEnabled() {
        return this.environmentService.isWebsocketEnabled();
    }
}
